import type { FC } from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ClearIcon from '@mui/icons-material/Clear';
import ReactMultiDatePicker from 'react-multi-date-picker';
import type { FilterSize } from './filterSize';
import { DEFAULT_FILTER_SIZE } from './filterSize';

interface TpcFinishDateInputProps {
  value: string | null;
  onChange: (val: string | null) => void;
  label?: string;
  minWidth?: number;
  size?: FilterSize;
}

const DATE_FORMAT = 'YYYY-MM-DD';

const TpcFinishDateInput: FC<TpcFinishDateInputProps> = ({
  value,
  onChange,
  label = 'TPC before',
  minWidth = 150,
  size = DEFAULT_FILTER_SIZE,
}) => {
  return (
    <Box
      sx={(t) => ({
        minWidth,
        '& .rmdp-container': { width: '100%' },
        '& .rmdp-day.rmdp-today span': {
          backgroundColor: `${t.palette.primary.light} !important`,
          color: t.palette.text.primary,
        },
        '& .rmdp-day.rmdp-selected span:not(.highlight)': {
          backgroundColor: `${t.palette.primary.main} !important`,
          color: '#fff',
          boxShadow: 'none',
        },
        '& .rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) span:hover': {
          backgroundColor: t.palette.action.hover,
          color: t.palette.text.primary,
        },
        '& .rmdp-week-day': {
          color: t.palette.text.secondary,
        },
        '& .rmdp-arrow': {
          borderColor: t.palette.primary.main,
        },
        '& .rmdp-arrow-container:hover': {
          backgroundColor: t.palette.primary.main,
          boxShadow: 'none',
        },
        '& .rmdp-arrow-container:hover .rmdp-arrow': {
          borderColor: '#fff',
        },
        '& .rmdp-header-values, & .rmdp-header-values *': {
          color: t.palette.text.primary,
        },
      })}
    >
      <ReactMultiDatePicker
        value={value ?? ''}
        format={DATE_FORMAT}
        calendarPosition="bottom-end"
        fixMainPosition
        onChange={(date) => {
          onChange(date ? date.format(DATE_FORMAT) : null);
        }}
        render={(stringValue: string, openCalendar) => (
          <TextField
            size={size}
            label={label}
            value={stringValue}
            onClick={openCalendar}
            placeholder={DATE_FORMAT}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  {value ? (
                    <IconButton
                      size="small"
                      aria-label="Clear date"
                      onClick={(e) => {
                        e.stopPropagation();
                        onChange(null);
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <DateRangeIcon fontSize="small" color="action" />
                  )}
                </InputAdornment>
              ),
            }}
            sx={{ width: '100%' }}
          />
        )}
      />
    </Box>
  );
};

export default TpcFinishDateInput;
